import React from 'react';
import classnames from 'classnames';

import * as S from './SocialButtons.module.css';
import * as T from './SocialButtons.types';

import IconFb from '@paradigm/icons/src/mailru/social/fb.svg';
import IconOk from '@paradigm/icons/src/mailru/social/ok.svg';
import IconVk from '@paradigm/icons/src/mailru/social/vk.svg';
import IconTwitter from '@paradigm/icons/src/mailru/social/twitter.svg';

import { useLocation } from '@reach/router';

export const SocialButtons: React.FunctionComponent<T.ISocialButtonsProps> = ({
  className,
}) => {
  const [url, setUrl] = React.useState<string>();
  const [title, setTitle] = React.useState<string>();
  const { pathname } = useLocation();

  React.useEffect(() => {
    // @ts-ignore
    setUrl(encodeURIComponent(window.location.href));
  }, [pathname]);

  React.useEffect(() => {
    setTitle(document.title);
  });

  const wrapCalss = classnames(S.socialList, className);

  return (
    <div className={wrapCalss}>
      <a
        target="_blank"
        title="Поделиться в Вконтакте"
        aria-label="Поделиться в Вконтакте"
        rel="noopener noreferrer"
        href={`https://vk.com/share.php?url=${url}`}
        className={classnames(S.socialButton, S.socialButtonVk)}
      >
        <IconVk fill="white" height={16} width={16} />
      </a>
      <a
        target="_blank"
        title="Поделиться в Одноклассниках"
        aria-label="Поделиться в Одноклассниках"
        rel="noopener noreferrer"
        href={`https://connect.ok.ru/offer?url=${url}`}
        className={classnames(S.socialButton, S.socialButtonOk)}
      >
        <IconOk fill="white" height={16} width={16} />
      </a>
      <a
        target="_blank"
        title="Поделиться в Facebook"
        aria-label="Поделиться в Facebook"
        rel="noopener noreferrer"
        href={`https://www.facebook.com/sharer/sharer.php?u=${url}`}
        className={classnames(S.socialButton, S.socialButtonFb)}
      >
        <IconFb fill="white" height={16} width={16} />
      </a>
      <a
        target="_blank"
        title="Поделиться в Twitter"
        aria-label="Поделиться в Twitter"
        rel="noopener noreferrer"
        href={`https://twitter.com/share?text=${encodeURIComponent(
          title
        )}&url=${url}`}
        className={classnames(S.socialButton, S.socialButtonTwitter)}
      >
        <IconTwitter fill="white" height={16} width={16} />
      </a>
    </div>
  );
};
